// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2bduh","question":"Question_question__WdRVw","description":"Question_description__dom7C"};